import React, { Fragment } from 'react'

import { useTranslation } from '../../contexts/I18nContext'
import RecipeAccordionSection from '../RecipeAccordionSection'

import Styled from './RecipeScores.styled'

const RecipeScores = ({
  className,
  id,
  nutritionalRatingScores,
  nutritionalRatingProvider,
}) => {
  const { t } = useTranslation()
  return (
    <RecipeAccordionSection
      className={className}
      id={id}
      title={t('RECIPE.SCORES')}
      variant="primary"
      headerRight={
        <Styled.header>
          {nutritionalRatingScores.map((score) => (
            <Styled.headerScore
              key={score.id}
              src={score.vectorImageUrl}
              alt={score.label}
              title={score.label}
            />
          ))}
        </Styled.header>
      }
    >
      <Styled>
        {nutritionalRatingScores.map((score) => (
          <Fragment key={score.id}>
            <Styled.scoreLabel>
              <strong>{score.label}</strong>
            </Styled.scoreLabel>
            <p>{score.description}</p>
          </Fragment>
        ))}
        {nutritionalRatingProvider ? (
          <Styled.providerContainer>
            <Styled.providerLabel>
              {nutritionalRatingProvider.label}
            </Styled.providerLabel>
            <Styled.providerLink
              href={nutritionalRatingProvider.url}
              target="_blank"
              rel="noopener noreferer"
            >
              <Styled.providerLogo
                src={nutritionalRatingProvider.vectorImageUrl}
                alt={nutritionalRatingProvider.name}
              />
            </Styled.providerLink>
          </Styled.providerContainer>
        ) : null}
      </Styled>
    </RecipeAccordionSection>
  )
}

export default RecipeScores
